"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VFXContext = void 0;
const react_1 = require("react");
exports.VFXContext = react_1.createContext(null);
